export default {
  getRecurrentPricesModalIsOpen: (state) => state.recurrentPricesModalIsOpen,
  getRecurrentProduct: (state) => state.recurrentProduct,
};
